import type { SelectOption } from '../../common/Select';

const withUnspecified = (
  options: ReadonlyArray<SelectOption>
): ReadonlyArray<SelectOption> => [
  { value: '', label: 'prenatalExam.options.unspecified' },
  ...options,
];

export const DIPSTICK_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'negative', label: 'prenatalExam.options.negative' },
  { value: 'traces', label: 'prenatalExam.options.traces' },
  { value: '+', label: 'prenatalExam.options.positive1' },
  { value: '++', label: 'prenatalExam.options.positive2' },
  { value: '+++', label: 'prenatalExam.options.positive3' },
]);

export const ALBUMINURIA_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'negative', label: 'prenatalExam.options.negative' },
  { value: 'traces', label: 'prenatalExam.options.traces' },
  { value: '+', label: 'prenatalExam.options.positive1' },
  { value: '++', label: 'prenatalExam.options.positive2' },
  { value: '+++', label: 'prenatalExam.options.positive3' },
  { value: '++++', label: 'prenatalExam.options.positive4' },
]);

export const YES_NO_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'yes', label: 'prenatalExam.options.yes' },
  { value: 'no', label: 'prenatalExam.options.no' },
]);

export const EDEMA_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'absent', label: 'prenatalExam.options.edemaAbsent' },
  {
    value: 'mild_lower_limbs',
    label: 'prenatalExam.options.edemaLowerLimbsMild',
  },
  {
    value: 'moderate_lower_limbs',
    label: 'prenatalExam.options.edemaLowerLimbsModerate',
  },
  {
    value: 'severe_lower_limbs',
    label: 'prenatalExam.options.edemaLowerLimbsSevere',
  },
  { value: 'generalized', label: 'prenatalExam.options.edemaGeneralized' },
  { value: 'other', label: 'prenatalExam.options.other' },
  { value: 'not_assessed', label: 'prenatalExam.options.notAssessed' },
]);

export const SKELETAL_ABNORMALITIES_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  {
    value: 'unremarkable',
    label: 'prenatalExam.options.skeletalUnremarkable',
  },
  {
    value: 'not_observed',
    label: 'prenatalExam.options.skeletalNotObserved',
  },
  { value: 'suspected', label: 'prenatalExam.options.skeletalSuspected' },
  { value: 'present', label: 'prenatalExam.options.skeletalPresent' },
  {
    value: 'suspected_dysplasia',
    label: 'prenatalExam.options.skeletalSuspectedDysplasia',
  },
  { value: 'short_limb', label: 'prenatalExam.options.skeletalShortLimb' },
  { value: 'clubfoot', label: 'prenatalExam.options.skeletalClubfoot' },
  {
    value: 'polydactyly',
    label: 'prenatalExam.options.skeletalPolydactyly',
  },
  {
    value: 'other_anomaly',
    label: 'prenatalExam.options.other',
  },
  { value: 'not_assessed', label: 'prenatalExam.options.notAssessed' },
]);

export const CONJUNCTIVA_PALMS_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  {
    value: 'normal',
    label: 'prenatalExam.options.conjunctivaNormal',
  },
  {
    value: 'pallor_absent',
    label: 'prenatalExam.options.conjunctivaPallorAbsent',
  },
  {
    value: 'pallor_mild',
    label: 'prenatalExam.options.conjunctivaPallorMild',
  },
  {
    value: 'pallor_moderate',
    label: 'prenatalExam.options.conjunctivaPallorModerate',
  },
  {
    value: 'pallor_severe',
    label: 'prenatalExam.options.conjunctivaPallorSevere',
  },
  { value: 'jaundice', label: 'prenatalExam.options.conjunctivaJaundice' },
  { value: 'cyanosis', label: 'prenatalExam.options.conjunctivaCyanosis' },
  { value: 'other', label: 'prenatalExam.options.other' },
  { value: 'not_assessed', label: 'prenatalExam.options.notAssessed' },
]);

export const BREAST_EXAM_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'normal', label: 'prenatalExam.options.breastNormal' },
  {
    value: 'nipples_normal',
    label: 'prenatalExam.options.breastNipplesNormal',
  },
  {
    value: 'inverted_nipples',
    label: 'prenatalExam.options.breastInvertedNipples',
  },
  { value: 'cracks', label: 'prenatalExam.options.breastCracks' },
  { value: 'mastitis', label: 'prenatalExam.options.breastMastitis' },
  { value: 'discharge', label: 'prenatalExam.options.breastDischarge' },
  { value: 'mass', label: 'prenatalExam.options.breastMass' },
  {
    value: 'other_anomaly',
    label: 'prenatalExam.options.other',
  },
  { value: 'not_examined', label: 'prenatalExam.options.notExamined' },
]);

export const RUBEOLA_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'immune', label: 'prenatalExam.options.serologyImmune' },
  { value: 'not_immune', label: 'prenatalExam.options.serologyNotImmune' },
  { value: 'igm_positive', label: 'prenatalExam.options.igmPositive' },
  { value: 'igg_positive', label: 'prenatalExam.options.iggPositive' },
  { value: 'unknown', label: 'prenatalExam.options.unknown' },
  { value: 'not_done', label: 'prenatalExam.options.serologyNotDone' },
]);

export const TOXOPLASMOSIS_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'immune', label: 'prenatalExam.options.serologyImmune' },
  { value: 'not_immune', label: 'prenatalExam.options.serologyNotImmune' },
  { value: 'igm_positive', label: 'prenatalExam.options.igmPositive' },
  { value: 'igg_positive', label: 'prenatalExam.options.iggPositive' },
  {
    value: 'suspected_seroconversion',
    label: 'prenatalExam.options.suspectedSeroconversion',
  },
  { value: 'not_done', label: 'prenatalExam.options.serologyNotDone' },
]);

export const HIV_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'negative', label: 'prenatalExam.options.negative' },
  { value: 'positive', label: 'prenatalExam.options.serologyPositive' },
  { value: 'indeterminate', label: 'prenatalExam.options.indeterminate' },
  { value: 'not_done', label: 'prenatalExam.options.serologyNotDone' },
]);

export const HBS_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'negative', label: 'prenatalExam.options.negative' },
  { value: 'positive', label: 'prenatalExam.options.serologyPositive' },
  { value: 'indeterminate', label: 'prenatalExam.options.indeterminate' },
  { value: 'not_done', label: 'prenatalExam.options.serologyNotDone' },
]);

export const SYPHILIS_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'negative', label: 'prenatalExam.options.negative' },
  { value: 'positive', label: 'prenatalExam.options.serologyPositive' },
  { value: 'treated', label: 'prenatalExam.options.treated' },
  { value: 'indeterminate', label: 'prenatalExam.options.indeterminate' },
  { value: 'not_done', label: 'prenatalExam.options.serologyNotDone' },
]);

export const RAI_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'negative', label: 'prenatalExam.options.negative' },
  { value: 'positive_anti_d', label: 'prenatalExam.options.raiPositiveAntiD' },
  { value: 'positive_anti_c', label: 'prenatalExam.options.raiPositiveAntiC' },
  { value: 'positive_anti_e', label: 'prenatalExam.options.raiPositiveAntiE' },
  {
    value: 'positive_anti_kell',
    label: 'prenatalExam.options.raiPositiveAntiKell',
  },
  { value: 'other_antibody', label: 'prenatalExam.options.other' },
  { value: 'not_done', label: 'prenatalExam.options.serologyNotDone' },
]);

export const OTHER_LAB_RESULT_OPTIONS: ReadonlyArray<SelectOption> = [
  { value: 'normal', label: 'prenatalExam.options.labNormal' },
  { value: 'high_crp', label: 'prenatalExam.options.labHighCrp' },
  { value: 'low_ferritin', label: 'prenatalExam.options.labLowFerritin' },
  { value: 'high_ferritin', label: 'prenatalExam.options.labHighFerritin' },
  { value: 'abnormal_tsh', label: 'prenatalExam.options.labAbnormalTsh' },
  { value: 'low_vitamin_d', label: 'prenatalExam.options.labLowVitaminD' },
  {
    value: 'low_vitamin_b12',
    label: 'prenatalExam.options.labLowVitaminB12',
  },
  {
    value: 'liver_abnormality',
    label: 'prenatalExam.options.labLiverAbnormality',
  },
  {
    value: 'renal_abnormality',
    label: 'prenatalExam.options.labRenalAbnormality',
  },
  { value: 'other', label: 'prenatalExam.options.other' },
];

export const SPECULUM_EXAM_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'normal', label: 'prenatalExam.options.speculumNormal' },
  {
    value: 'cervix_closed',
    label: 'prenatalExam.options.speculumCervixClosed',
  },
  {
    value: 'cervix_partially_open',
    label: 'prenatalExam.options.speculumCervixPartiallyOpen',
  },
  {
    value: 'physiologic_leucorrhea',
    label: 'prenatalExam.options.speculumPhysiologicLeucorrhea',
  },
  {
    value: 'pathologic_leucorrhea',
    label: 'prenatalExam.options.speculumPathologicLeucorrhea',
  },
  {
    value: 'metrorrhagia',
    label: 'prenatalExam.options.speculumMetrorrhagia',
  },
  {
    value: 'suspected_membrane_rupture',
    label: 'prenatalExam.options.speculumSuspectedMembraneRupture',
  },
  {
    value: 'cervical_infection',
    label: 'prenatalExam.options.speculumCervicalInfection',
  },
  {
    value: 'other_anomaly',
    label: 'prenatalExam.options.other',
  },
  { value: 'not_done', label: 'prenatalExam.options.serologyNotDone' },
]);

export const CERVICAL_STATE_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  {
    value: 'long_closed',
    label: 'prenatalExam.options.cervicalLongClosed',
  },
  { value: 'long', label: 'prenatalExam.options.cervicalLong' },
  { value: 'mid_length', label: 'prenatalExam.options.cervicalMidLength' },
  { value: 'short', label: 'prenatalExam.options.cervicalShort' },
  { value: 'effaced', label: 'prenatalExam.options.cervicalEffaced' },
  { value: 'open_1_cm', label: 'prenatalExam.options.cervicalOpen1Cm' },
  { value: 'open_2_cm', label: 'prenatalExam.options.cervicalOpen2Cm' },
  {
    value: 'open_3_cm_or_more',
    label: 'prenatalExam.options.cervicalOpen3CmOrMore',
  },
  { value: 'other', label: 'prenatalExam.options.other' },
  { value: 'not_assessed', label: 'prenatalExam.options.notAssessed' },
]);

export const PELVIC_ASSESSMENT_OPTIONS: ReadonlyArray<SelectOption> = withUnspecified([
  { value: 'normal', label: 'prenatalExam.options.pelvisNormal' },
  {
    value: 'clinically_adequate',
    label: 'prenatalExam.options.pelvisClinicallyAdequate',
  },
  { value: 'borderline', label: 'prenatalExam.options.pelvisBorderline' },
  { value: 'contracted', label: 'prenatalExam.options.pelvisContracted' },
  { value: 'asymmetric', label: 'prenatalExam.options.pelvisAsymmetric' },
  { value: 'other', label: 'prenatalExam.options.other' },
  { value: 'not_assessed', label: 'prenatalExam.options.notAssessed' },
]);

export const TREATMENT_OPTIONS: ReadonlyArray<SelectOption> = [
  { value: 'none', label: 'prenatalExam.options.treatmentNone' },
  { value: 'iron', label: 'prenatalExam.options.treatmentIron' },
  {
    value: 'folic_acid',
    label: 'prenatalExam.options.treatmentFolicAcid',
  },
  { value: 'vitamin_d', label: 'prenatalExam.options.treatmentVitaminD' },
  { value: 'calcium', label: 'prenatalExam.options.treatmentCalcium' },
  {
    value: 'low_dose_aspirin',
    label: 'prenatalExam.options.treatmentLowDoseAspirin',
  },
  { value: 'heparin', label: 'prenatalExam.options.treatmentHeparin' },
  {
    value: 'antihypertensive',
    label: 'prenatalExam.options.treatmentAntihypertensive',
  },
  { value: 'insulin', label: 'prenatalExam.options.treatmentInsulin' },
  {
    value: 'metformin',
    label: 'prenatalExam.options.treatmentMetformin',
  },
  {
    value: 'antibiotic',
    label: 'prenatalExam.options.treatmentAntibiotic',
  },
  {
    value: 'progesterone',
    label: 'prenatalExam.options.treatmentProgesterone',
  },
  { value: 'other', label: 'prenatalExam.options.other' },
];

export const DRUG_CLASS_OPTIONS: ReadonlyArray<SelectOption> = [
  { value: 'none', label: 'prenatalExam.options.drugClassNone' },
  {
    value: 'antianemic',
    label: 'prenatalExam.options.drugClassAntianemic',
  },
  { value: 'vitamins', label: 'prenatalExam.options.drugClassVitamins' },
  {
    value: 'antihypertensive',
    label: 'prenatalExam.options.drugClassAntihypertensive',
  },
  {
    value: 'antidiabetic',
    label: 'prenatalExam.options.drugClassAntidiabetic',
  },
  {
    value: 'anticoagulant',
    label: 'prenatalExam.options.drugClassAnticoagulant',
  },
  {
    value: 'antibiotic',
    label: 'prenatalExam.options.drugClassAntibiotic',
  },
  {
    value: 'antifungal',
    label: 'prenatalExam.options.drugClassAntifungal',
  },
  { value: 'antiviral', label: 'prenatalExam.options.drugClassAntiviral' },
  { value: 'hormonal', label: 'prenatalExam.options.drugClassHormonal' },
  { value: 'analgesic', label: 'prenatalExam.options.drugClassAnalgesic' },
  { value: 'other', label: 'prenatalExam.options.other' },
];
